import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Loader from './Loader';
import Breadcrumb from './Breadcrumb';
import Navbar from './Navbar';
import NavbarAuth from './NavbarAuth';
import NavbarSesion from './NavbarSesion';
import Footer from './Footer';

const Layout = ({ children }) => {

    const { isAuthenticated } = useSelector(state => state.auth);
    const loaderCount = useSelector(state => state.loader.count);

    const location = useLocation();

    const loading = loaderCount > 0;

    const layoutAdmin = (
        <Fragment>
            {loading && <Loader></Loader>}
            <NavbarSesion></NavbarSesion>
            <section className="container-fluid principal-section">
                <Breadcrumb />
                { children }
            </section>
        </Fragment>
    );

    const layoutGuest = (
        <Fragment>
            {(location.pathname != '/login' && location.pathname != '/register') ? <Navbar></Navbar> : <NavbarAuth></NavbarAuth>}
            { children }
            {(location.pathname != '/login' && location.pathname != '/register') && <Footer></Footer>}
        </Fragment>
    );

    if(isAuthenticated){
        return layoutAdmin;
    } else{
        return layoutGuest;
    }
}

export default Layout;